import crypto from 'crypto';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom'; // Unique ID creation requires a high quality random # generator.  In node.js
// this is pretty straight-forward - we use the crypto API.

var rng = function nodeRNG() {
  return crypto.randomBytes(16);
};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */


var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

var bytesToUuid_1 = bytesToUuid;

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }

  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid_1(rnds);
}

var v4_1 = v4;
var ScannerContext = React.createContext({
  elements: {}
});

var checkVisible = function checkVisible(element) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'visible';
  var rect = element.getBoundingClientRect();
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  var above = rect.bottom - threshold < 0;
  var below = rect.top - viewHeight + threshold >= 0;
  var isVisible = !above && !below;

  if (mode === 'above') {
    isVisible = above;
  }

  if (mode === 'below') {
    isVisible = below;
  }

  return {
    isVisible: isVisible,
    above: above,
    below: below,
    rect: rect,
    viewHeight: viewHeight
  };
};

var checkVisibleAndScroll = function checkVisibleAndScroll(element) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'visible';
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  var fixedThreshold = viewHeight * threshold / 100;

  var _checkVisible = checkVisible(element, fixedThreshold, mode),
      isVisible = _checkVisible.isVisible,
      rect = _checkVisible.rect;

  var _window = window,
      scrollX = _window.scrollX,
      scrollY = _window.scrollY;

  if (!isVisible) {
    var elementPosY = scrollY + rect.top - fixedThreshold;
    window.scrollTo(scrollX, elementPosY);
    element.scrollIntoView();
  }
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Scannable = function (_React$Component) {
  inherits(Scannable, _React$Component);

  function Scannable(props) {
    classCallCheck(this, Scannable);

    var _this = possibleConstructorReturn(this, (Scannable.__proto__ || Object.getPrototypeOf(Scannable)).call(this, props));

    _this.scannableId = v4_1();
    _this.isFocused = false;
    return _this;
  }

  createClass(Scannable, [{
    key: 'isEnabled',
    value: function isEnabled() {
      return !this.props.disabled;
    }
  }, {
    key: 'onSelect',
    value: function onSelect(event) {
      this.props.onSelect(event, this, this.props.scanner);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scanner = this.props.scanner;

      if (scanner && scanner.addScannableElement) {
        scanner.addScannableElement(this);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref) {
      var disabled = _ref.disabled;

      if (disabled !== this.props.disabled) {
        var scanner = this.props.scanner;
        scanner.updateScannableElement(this);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          scanner = _props.scanner,
          disabled = _props.disabled,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          other = objectWithoutProperties(_props, ['children', 'scanner', 'disabled', 'onFocus', 'onBlur']);
      var focusedItem = scanner.focusedItem,
          config = scanner.config;
      var childrenWithProps = children;

      if (config) {
        var focusedClassName = config.focusedClassName,
            focusedVisibleThreshold = config.focusedVisibleThreshold;
        childrenWithProps = React.Children.map(children, function (child) {
          var classes = [child.props.className || ''];
          var isFocused = focusedItem.element && focusedItem.element.scannableId === _this2.scannableId;
          var isBlurred = _this2.isFocused && !isFocused;
          _this2.isFocused = isFocused;

          if (isFocused) {
            classes.push(focusedClassName);
            checkVisibleAndScroll(focusedItem.node, focusedVisibleThreshold);
            onFocus(_this2, scanner);
          } else if (isBlurred) {
            onBlur(_this2, scanner);
          }

          var className = classes.join(' ').trim();
          return React.cloneElement(child, _extends({
            className: className
          }, other));
        });
      }

      return React.createElement(React.Fragment, null, childrenWithProps);
    }
  }]);
  return Scannable;
}(React.Component);

Scannable.defaultProps = {
  disabled: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onSelect: function onSelect() {}
};
Scannable.propTypes = {
  children: PropTypes.node.isRequired,
  scanner: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onSelect: PropTypes.func
};

var WithScanner = function WithScanner(Component) {
  return function (props) {
    return React.createElement(ScannerContext.Consumer, null, function (scannerContext) {
      return React.createElement(Component, _extends({}, props, {
        scanner: scannerContext
      }));
    });
  };
};

var Scannable$1 = WithScanner(Scannable);
var SCANNER_STRATEGY = 'automatic';
var SCANNER_EVENTS = ['click', 'keydown', 'contextmenu'];
var SCANNER_CLASSNAME = 'Scanner__Container';
var SCANNER_SELECT_DEBOUNCE_TIME = 400;
var SCANNER_SELECT_KEYCODES = ['enter', 'backspace', 13, 8];
var SCANNER_AUTODEACTIVATE_KEYCODES = ['scape', 27];
var SCANNER_AUTODEACTIVATE_COUNT = 4;
var SCANNER_ADVANCE_KEYCODES = ['*', 'spacebar', 'tab', 'rightArrow', 'downArrow', 32, 9];
var SCANNER_SELECT_CLICKEVENT = 'contextmenu';
var SCANNER_ADVANCE_CLICKEVENT = 'click';
var SCANNER_MOVE_BACK_KEYS = ['leftArrow', 'upArrow'];
var SCANNER_CLASSNAME_ACTIVE = 'Scanner__Container Scanner__Container--active';
var SCANNER_ITERATION_INTERVAL = 2000;
var SCANNABLE_FOCUSED_CLASSNAME = 'scanner__focused';
var SCANNABLE_FOCUSED_VISIBLE_THRESHOLD = 5;
var KEY_CODE_MAP = {
  enter: 13,
  backspace: 8,
  spacebar: 32,
  tab: 9,
  shift: 16,
  control: 17,
  alt: 18,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  escape: 27
}; // https://gist.github.com/nmsdvid/8807205#gistcomment-2595895
// const debounce = (callback, time = 250, debounceInterval) => (...args) =>
//   clearTimeout(debounceInterval, (debounceInterval = setTimeout(() => callback(...args), time)));

var debounce = function debounce(callback) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var timeout = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (immediate && !timeout) {
      callback.apply(undefined, args);
    }

    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;

      if (!immediate) {
        callback.apply(undefined, args);
      }
    }, time);
  };
};

var dispatchEvent = function dispatchEvent(element, event) {
  var node = element.node;
  var eventToDispatch = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false
  });
  node.dispatchEvent(eventToDispatch);
};

var configKeys = ['advanceClickEvent', 'advanceKeyCodes', 'moveBackKeyCodes', 'autoDeactivateCount', 'autoDeactivateKeyCodes', 'className', 'classNameActive', 'events', 'iterationInterval', 'focusedClassName', 'focusedVisibleThreshold', 'selectClickEvent', 'selectDebounceTime', 'selectKeyCodes', 'strategy', 'target'];

var getConfig = function getConfig(props) {
  var config = {};
  var propsKeys = Object.keys(props).filter(function (k) {
    return configKeys.indexOf(k) >= 0;
  });
  propsKeys.forEach(function (k) {
    config[k] = props[k];
  });
  return config;
};

var BaseStrategy = function () {
  function BaseStrategy(scanner) {
    classCallCheck(this, BaseStrategy);
    this.scanner = scanner;
    this.config = scanner.config;
  }

  createClass(BaseStrategy, [{
    key: 'activate',
    value: function activate() {
      console.log('Scanner should be activated');
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      console.log('Scanner should be deactivated');
    }
  }, {
    key: 'checkAutoDeactivation',
    value: function checkAutoDeactivation(event) {
      console.log('Strategy should provide a checkAutoDeactivation function');
    }
  }, {
    key: 'getNextScannableId',
    value: function getNextScannableId() {
      var focusedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scanner.state.focusedId;
      var keysToIterate = this.scanner.state.keysToIterate;
      var nextFocusedIndex = keysToIterate.indexOf(focusedId) + 1;
      return nextFocusedIndex < keysToIterate.length ? keysToIterate[nextFocusedIndex] : keysToIterate[0];
    }
  }, {
    key: 'getPrevScannableId',
    value: function getPrevScannableId() {
      var focusedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scanner.state.focusedId;
      var keysToIterate = this.scanner.state.keysToIterate;
      var nextFocusedIndex = keysToIterate.indexOf(focusedId) - 1;
      return nextFocusedIndex >= 0 ? keysToIterate[nextFocusedIndex] : keysToIterate[keysToIterate.length - 1];
    }
  }, {
    key: 'dispatchEvent',
    value: function dispatchEvent(scannable, event) {
      this.scanner.setSelectedElement(scannable, event);
      utils.dispatchEvent(scannable, event);
      scannable.element.onSelect(event);
    }
  }, {
    key: 'selectElement',
    value: function selectElement(scannable, event) {
      var selectedPath = [];

      if (scannable && scannable.treeId) {
        if (scannable.children) {
          selectedPath = this.scanner.state.selectedPath.concat(scannable.treeId);
        } else {
          this.dispatchEvent(scannable, event);
        }
      }

      this.scanner.setSelectedPath(selectedPath);
    }
  }]);
  return BaseStrategy;
}();

var AutomaticStrategy = function (_BaseStrategy) {
  inherits(AutomaticStrategy, _BaseStrategy);

  function AutomaticStrategy(scanner) {
    classCallCheck(this, AutomaticStrategy);

    var _this = possibleConstructorReturn(this, (AutomaticStrategy.__proto__ || Object.getPrototypeOf(AutomaticStrategy)).call(this, scanner));

    _this.autoDeactivationCounter = 0;
    _this.autoDeactivationToutFn = null;
    _this.autoDeactivationKeyCodes = new Set(scanner.config.autoDeactivateKeyCodes.map(function (kc) {
      return KEY_CODE_MAP[kc] || kc;
    }));
    return _this;
  }

  createClass(AutomaticStrategy, [{
    key: 'activate',
    value: function activate() {
      var _this2 = this;

      this.clearIterateInterval();

      if (this.scanner.state.keysToIterate.length) {
        this.iterateIntervalFn = setInterval(function () {
          var newFocusedId = _this2.getNextScannableId();

          _this2.scanner.focusScannable(newFocusedId);
        }, this.config.iterationInterval);
      }
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      this.clearIterateInterval();
    }
  }, {
    key: 'checkAutoDeactivation',
    value: function checkAutoDeactivation(event) {
      var _this3 = this;

      var eventType = event.type,
          keyCode = event.keyCode;

      if (eventType === 'keydown') {
        if (this.autoDeactivationKeyCodes.has(keyCode)) {
          if (this.autoDeactivationToutFn) {
            clearTimeout(this.autoDeactivationToutFn);
          }

          this.autoDeactivationCounter = this.autoDeactivationCounter + 1;

          if (this.autoDeactivationCounter >= this.scanner.config.autoDeactivateCount) {
            this.deactivate();
            this.scanner.triggerDeactivation();
            this.autoDeactivationCounter = 0;
          } else {
            this.autoDeactivationToutFn = setTimeout(function () {
              _this3.autoDeactivationCounter = 0;
            }, 600);
          }

          return false;
        }
      }

      return true;
    }
  }, {
    key: 'clearIterateInterval',
    value: function clearIterateInterval() {
      if (this.iterateIntervalFn) {
        clearInterval(this.iterateIntervalFn);
      }
    }
  }]);
  return AutomaticStrategy;
}(BaseStrategy);

var ManualStrategy = function (_BaseStrategy) {
  inherits(ManualStrategy, _BaseStrategy);

  function ManualStrategy(scanner) {
    classCallCheck(this, ManualStrategy);

    var _this = possibleConstructorReturn(this, (ManualStrategy.__proto__ || Object.getPrototypeOf(ManualStrategy)).call(this, scanner));

    var _scanner$config = scanner.config,
        selectClickEvent = _scanner$config.selectClickEvent,
        advanceClickEvent = _scanner$config.advanceClickEvent,
        moveBackKeyCodes = _scanner$config.moveBackKeyCodes,
        selectKeyCodes = _scanner$config.selectKeyCodes,
        advanceKeyCodes = _scanner$config.advanceKeyCodes,
        autoDeactivateKeyCodes = _scanner$config.autoDeactivateKeyCodes;
    _this.selectClickEvent = selectClickEvent;
    _this.advanceClickEvent = advanceClickEvent;
    _this.selectKeyCodes = new Set(selectKeyCodes.map(function (kc) {
      return KEY_CODE_MAP[kc] || kc;
    }));
    _this.advanceKeyCodes = new Set(advanceKeyCodes.map(function (kc) {
      return KEY_CODE_MAP[kc] || kc;
    }));
    _this.moveBackKeyCodes = new Set(moveBackKeyCodes.map(function (kc) {
      return KEY_CODE_MAP[kc] || kc;
    }));
    _this.autoDeactivationCounter = 0;
    _this.autoDeactivationToutFn = null;
    _this.autoDeactivationKeyCodes = new Set(autoDeactivateKeyCodes.map(function (kc) {
      return KEY_CODE_MAP[kc] || kc;
    }));
    _this.isActive = false;
    return _this;
  }

  createClass(ManualStrategy, [{
    key: 'activate',
    value: function activate() {
      this.isActive = true;
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      this.isActive = false;
    }
  }, {
    key: 'checkAutoDeactivation',
    value: function checkAutoDeactivation(event) {
      var _this2 = this;

      var eventType = event.type,
          keyCode = event.keyCode;

      if (eventType === 'keydown') {
        if (this.autoDeactivationKeyCodes.has(keyCode)) {
          if (this.autoDeactivationToutFn) {
            clearTimeout(this.autoDeactivationToutFn);
          }

          this.autoDeactivationCounter = this.autoDeactivationCounter + 1;

          if (this.autoDeactivationCounter >= this.scanner.config.autoDeactivateCount) {
            this.deactivate();
            this.scanner.triggerDeactivation();
            this.autoDeactivationCounter = 0;
          } else {
            this.autoDeactivationToutFn = setTimeout(function () {
              _this2.autoDeactivationCounter = 0;
            }, 600);
          }

          return false;
        }
      }

      return true;
    }
  }, {
    key: 'selectElement',
    value: function selectElement(scannable, event) {
      var eventType = event.type,
          keyCode = event.keyCode;
      var reverse = this.moveBackKeyCodes.has(keyCode);

      switch (eventType) {
        case 'keydown':
          if (this.selectKeyCodes.has(keyCode)) {
            this.select(scannable, event);
          } else if (reverse || this.advanceKeyCodes.has(keyCode) || this.advanceKeyCodes.has('*')) {
            this.advance(scannable, event, reverse);
          }

          break;

        case this.selectClickEvent:
          this.select(scannable, event);
          break;

        case this.advanceClickEvent:
          this.advance(scannable, event);
          break;

        default:
          break;
      }
    }
  }, {
    key: 'advance',
    value: function advance(scannable, event) {
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var action = reverse ? 'getPrevScannableId' : 'getNextScannableId';
      var newFocusedId = this[action]();
      this.scanner.focusScannable(newFocusedId);
    }
  }, {
    key: 'select',
    value: function select(scannable, event) {
      var selectedPath = [];

      if (scannable && scannable.treeId) {
        if (scannable.children) {
          selectedPath = this.scanner.state.selectedPath.concat(scannable.treeId);
        } else {
          this.dispatchEvent(scannable, event);
        }
      }

      this.scanner.setSelectedPath(selectedPath);
    }
  }]);
  return ManualStrategy;
}(BaseStrategy);

var Strategies = {
  automatic: AutomaticStrategy,
  manual: ManualStrategy
};

var getStrategy = function getStrategy(strategyName, scanner) {
  var StrategyConstructor = Strategies[strategyName] || Strategies.automatic;
  return new StrategyConstructor(scanner);
};

var getScannableChildrenOfElement = function getScannableChildrenOfElement(element, scannables) {
  var scannableNodes = scannables.map(function (_ref) {
    var node = _ref.node;
    return node;
  });
  var elementChildren = Array.from(element.children || []);
  var scannableChildren = [];

  if (elementChildren.length) {
    elementChildren.forEach(function (child) {
      var index = scannableNodes.indexOf(child);

      if (index >= 0) {
        var scannableChild = scannables[index];
        scannableChildren.push(scannableChild);
      } else if (child.children && child.children.length) {
        scannableChildren = scannableChildren.concat(getScannableChildrenOfElement(child, scannables));
      }
    });
  }

  return scannableChildren;
};

var getTreeForElement = function getTreeForElement(elementNode, scannables) {
  var scannableChildren = getScannableChildrenOfElement(elementNode, scannables);
  var newScannables = scannables.filter(function (e) {
    return scannableChildren.indexOf(e) < 0;
  });
  scannableChildren.forEach(function (sc) {
    if (sc.node.children && sc.node.children.length) {
      sc.children = getTreeForElement(sc.node, newScannables);
    }
  });
  var tree = scannableChildren.reduce(function (prev, sc, i) {
    var treeId = i + "_" + sc.element.scannableId;
    prev[treeId] = _extends({}, sc, {
      treeId: treeId
    });

    if (sc.children && Object.keys(sc.children).length === 0) {
      delete prev[treeId].children;
    }

    return prev;
  }, {});
  return tree;
};

var utils = {
  checkVisible: checkVisible,
  checkVisibleAndScroll: checkVisibleAndScroll,
  debounce: debounce,
  dispatchEvent: dispatchEvent,
  getConfig: getConfig,
  getStrategy: getStrategy,
  getTreeForElement: getTreeForElement
}; // https://github.com/tc39/proposal-object-values-entries/blob/master/polyfill.js

var reduce = Function.bind.call(Function.call, Array.prototype.reduce);
var isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
var concat = Function.bind.call(Function.call, Array.prototype.concat);
var keys = Reflect.ownKeys;

if (!Object.values) {
  Object.values = function values(O) {
    return reduce(keys(O), function (v, k) {
      return concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : []);
    }, []);
  };
}

if (!Object.entries) {
  Object.entries = function entries(O) {
    return reduce(keys(O), function (e, k) {
      return concat(e, typeof k === 'string' && isEnumerable(O, k) ? [[k, O[k]]] : []);
    }, []);
  };
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".Scanner__Container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n}\n\n.Scanner__EventsHandler {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.scanner__focused {\n  outline: 4px solid rgba(255, 0, 0, 1);\n  outline-offset: -4px;\n}\n";
styleInject(css);
var getConfig$1 = utils.getConfig,
    getStrategy$1 = utils.getStrategy,
    getTreeForElement$1 = utils.getTreeForElement,
    debounce$1 = utils.debounce;
var SCANNER_INITIAL_STATE = {
  selectedPath: [],
  elementsToIterate: {},
  keysToIterate: [],
  focusedId: 'not-valid-id'
};

var Scanner = function (_React$Component) {
  inherits(Scanner, _React$Component);

  function Scanner(props) {
    classCallCheck(this, Scanner);

    var _this = possibleConstructorReturn(this, (Scanner.__proto__ || Object.getPrototypeOf(Scanner)).call(this, props));

    _this.scannerEventAction = function (event) {
      var active = _this.props.active;
      var shouldContinue = true;

      if (_this.config.autoDeactivateCount) {
        shouldContinue = _this.strategy.checkAutoDeactivation(event);
      }

      if (!shouldContinue) {
        _this.props.onAutoDeactivateAction(event);
      }

      if (active && shouldContinue && !_this.selectedElement) {
        event.preventDefault();
        event.stopPropagation();
        var elementToSelect = _this.state.elementsToIterate[_this.state.focusedId];

        if (elementToSelect) {
          _this.debouncedSelectElement(elementToSelect, event);
        }
      }
    };

    _this.addScannableElement = function (element) {
      _this.elements[element.scannableId] = {
        element: element,
        node: ReactDOM.findDOMNode(element)
      };

      if (_this.props.active) {
        _this.findNodes();
      }
    };

    _this.updateScannableElement = function (element) {
      _this.elements[element.scannableId] = {
        element: element,
        node: ReactDOM.findDOMNode(element)
      };
      var focusedId = _this.state.focusedId;

      if (element.scannableId === focusedId) {
        focusedId = _this.strategy.getNextScannableId(focusedId);
      }

      _this.findNodes();

      _this.iterateScannableElements(focusedId);
    };

    _this.onScannableFocus = function () {
      var focusedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.focusedId;

      var _ref = _this.state.elementsToIterate[focusedId] || {},
          element = _ref.element;

      if (element) {
        _this.props.onFocus(element, _this);
      }
    };

    _this.reset = function () {
      _this.strategy.deactivate();

      _this.findNodes();

      _this.setState(SCANNER_INITIAL_STATE, _this.iterateScannableElements);
    };

    _this.state = SCANNER_INITIAL_STATE;
    _this.scannerNode = null;
    _this.elements = {};
    _this.tree = {};
    _this.selectedElement = null;
    _this.config = getConfig$1(props);
    _this.strategy = getStrategy$1(_this.config.strategy, _this);
    _this.debouncedSelectElement = debounce$1(function (element, event) {
      _this.selectElement(element, event);
    }, _this.config.selectDebounceTime);
    _this.target = _this.config.target;
    return _this;
  }

  createClass(Scanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.registerEvents();

      if (this.props.active) {
        this.findNodes();
        this.iterateScannableElements();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unregisterEvents();
      this.strategy.deactivate();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.active !== this.props.active) {
        if (this.props.active) {
          this.findNodes();
          this.iterateScannableElements();
        } else {
          this.strategy.deactivate();
          this.setState(SCANNER_INITIAL_STATE);
        }
      }

      var newConfig = getConfig$1(this.props);

      if (newConfig.strategy !== this.config.strategy) {
        this.strategy.deactivate();
        this.strategy = getStrategy$1(newConfig.strategy, this);
      }

      this.config = newConfig;
      this.debouncedSelectElement = debounce$1(function (element, event) {
        _this2.selectElement(element, event);
      }, this.config.selectDebounceTime);
    }
  }, {
    key: 'triggerDeactivation',
    value: function triggerDeactivation() {
      this.props.onDeactivation();
      this.setState(SCANNER_INITIAL_STATE);
    }
  }, {
    key: 'findNodes',
    value: function findNodes() {
      this.scannerNode = ReactDOM.findDOMNode(this);
      var elementsArray = Object.values(this.elements);
      var children = getTreeForElement$1(this.scannerNode, elementsArray);
      this.tree = {
        children: children
      };
    }
  }, {
    key: 'getElementsToIterate',
    value: function getElementsToIterate() {
      var active = this.props.active;
      var elementsToIterate = {};
      var keysToIterate = [];

      if (!active) {
        return {
          elementsToIterate: elementsToIterate,
          keysToIterate: keysToIterate
        };
      }

      var current = this.tree;

      if (this.state.selectedPath.length) {
        current = this.state.selectedPath.reduce(function (prev, id) {
          prev = prev.children[id];
          return prev;
        }, current);
      }

      if (!current || !current.children) {
        current = {};
      }

      elementsToIterate = current.children || {};
      keysToIterate = Object.keys(elementsToIterate).filter(function (k) {
        return elementsToIterate[k].element.isEnabled();
      });
      return {
        elementsToIterate: elementsToIterate,
        keysToIterate: keysToIterate
      };
    }
  }, {
    key: 'selectElement',
    value: function selectElement(scannable, event) {
      if (scannable && scannable.treeId) {
        this.strategy.selectElement(scannable, event);
      }
    }
  }, {
    key: 'setSelectedElement',
    value: function setSelectedElement(scannable, event) {
      this.selectedElement = scannable;
      this.props.onSelect(event, scannable, this);
    }
  }, {
    key: 'setSelectedPath',
    value: function setSelectedPath() {
      var selectedPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.selectedPath;
      this.setState({
        selectedPath: selectedPath
      }, this.iterateScannableElements);
    }
  }, {
    key: 'focusScannable',
    value: function focusScannable(focusedId) {
      this.setState({
        focusedId: focusedId
      }, this.onScannableFocus);
    }
  }, {
    key: 'iterateScannableElements',
    value: function iterateScannableElements() {
      var _this3 = this;

      var focusedId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.focusedId;
      this.selectedElement = null;

      var _getElementsToIterate = this.getElementsToIterate(),
          elementsToIterate = _getElementsToIterate.elementsToIterate,
          keysToIterate = _getElementsToIterate.keysToIterate;

      var newFocusedId = elementsToIterate[focusedId] ? focusedId : keysToIterate[0];
      this.setState({
        elementsToIterate: elementsToIterate,
        keysToIterate: keysToIterate,
        focusedId: newFocusedId
      }, function () {
        _this3.onScannableFocus(newFocusedId);

        _this3.strategy.activate();
      });
    }
  }, {
    key: 'registerEvents',
    value: function registerEvents() {
      var _this4 = this;

      this.config.events.forEach(function (e) {
        return _this4.target.addEventListener(e, _this4.scannerEventAction);
      });
    }
  }, {
    key: 'unregisterEvents',
    value: function unregisterEvents() {
      var _this5 = this;

      this.config.events.forEach(function (e) {
        return _this5.target.removeEventListener(e, _this5.scannerEventAction);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          active = _props.active;
      var focusedItem = this.state.keysToIterate.length > 0 ? this.state.elementsToIterate[this.state.focusedId] : {};

      var contextValue = _extends({}, this.state, {
        config: this.config,
        focusedItem: focusedItem,
        addScannableElement: this.addScannableElement,
        updateScannableElement: this.updateScannableElement,
        reset: this.reset
      });

      var classes = active ? this.config.classNameActive : this.config.className;
      return React.createElement(ScannerContext.Provider, {
        value: contextValue
      }, React.createElement('div', {
        className: classes
      }, children));
    }
  }]);
  return Scanner;
}(React.Component);

Scanner.defaultProps = {
  active: false,
  autoDeactivateCount: SCANNER_AUTODEACTIVATE_COUNT,
  autoDeactivateKeyCodes: SCANNER_AUTODEACTIVATE_KEYCODES,
  advanceKeyCodes: SCANNER_ADVANCE_KEYCODES,
  advanceClickEvent: SCANNER_ADVANCE_CLICKEVENT,
  moveBackKeyCodes: SCANNER_MOVE_BACK_KEYS,
  className: SCANNER_CLASSNAME,
  classNameActive: SCANNER_CLASSNAME_ACTIVE,
  events: SCANNER_EVENTS,
  focusedClassName: SCANNABLE_FOCUSED_CLASSNAME,
  focusedVisibleThreshold: SCANNABLE_FOCUSED_VISIBLE_THRESHOLD,
  iterationInterval: SCANNER_ITERATION_INTERVAL,
  onSelect: function onSelect() {},
  onFocus: function onFocus() {},
  onAutoDeactivateAction: function onAutoDeactivateAction() {},
  onDeactivation: function onDeactivation() {},
  selectClickEvent: SCANNER_SELECT_CLICKEVENT,
  selectDebounceTime: SCANNER_SELECT_DEBOUNCE_TIME,
  selectKeyCodes: SCANNER_SELECT_KEYCODES,
  strategy: SCANNER_STRATEGY,
  target: document.body
};
Scanner.propTypes = {
  active: PropTypes.bool,
  autoDeactivateCount: PropTypes.number,
  autoDeactivateKeyCodes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  advanceKeyCodes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  advanceClickEvent: PropTypes.string,
  moveBackKeyCodes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  classNameActive: PropTypes.string,
  events: PropTypes.arrayOf(PropTypes.string),
  focusedClassName: PropTypes.string,
  focusedVisibleThreshold: PropTypes.number,
  iterationInterval: PropTypes.number,
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
  onAutoDeactivateAction: PropTypes.func,
  onDeactivation: PropTypes.func,
  selectClickEvent: PropTypes.string,
  selectDebounceTime: PropTypes.number,
  selectKeyCodes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  strategy: PropTypes.string,
  target: PropTypes.instanceOf(Element)
};
export { Scannable$1 as Scannable, Scanner };